import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../helpers';
import { AppContextProvider } from '../../Services/AppContext';
import SignatureFirstLogin from './SignatureFirstLogin';

loadDOMComponent({
	selector: 'react-signature-first-login',
	callback: ({ container, context }: any) => {
		const userId = container.getAttribute('userId');
		const workplaceId = container.getAttribute('workplaceId');
		const continueUrl = container.getAttribute('continueUrl');

		ReactDOM.render(
			<AppContextProvider {...context}>
				<SignatureFirstLogin
					userId={userId}
					workplaceId={workplaceId}
					continueUrl={continueUrl}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
